module.exports = __webpack_public_path__ + "static/img/close.18a8422.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/close.png
// module id = fgqV
// module chunks = 1